import apiService from 'src/enviroment'

// Empresa

const getEmpresas = async () => {
  try {
    const response = await apiService.get('/sostenibilidad/empresas')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}
const postEmpresa = async (body) => {
  try {
    const response = await apiService.post('/sostenibilidad/empresas', body)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

const editEmpresa = async (body) => {
  try {
    const response = await apiService.put('/sostenibilidad/empresas', body)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

  
const deleteEmpresa = async (id) => {
  try {
    const response = await apiService.delete(`/sostenibilidad/empresas?id=${id}`)
    if (response.status === 200) {
      return response
    }
    return false
      
  } catch (error) {
    return false
  }
}




// Ensambladoras

const getEnsambladoras = async () => {
  try {
    const response = await apiService.get('/sostenibilidad/ensambladoras')
    if (response.status === 200) {
      console.log(response.data)
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postEnsambladora = async (body) => {
  try {
    const response = await apiService.post('/sostenibilidad/ensambladoras', body)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

const putEnsambladora = async (body) => {
  try {
    const response = await apiService.put('/sostenibilidad/ensambladoras', body)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}


// Baterias

const getBaterias = async () => {
  try {
    const response = await apiService.get('/sostenibilidad/baterias')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postBateria = async (body) => {
  try {
    const response = await apiService.post('/sostenibilidad/baterias', body)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

const deleteBateria = async (id) => {
  try {
    const response = await apiService.delete(
      `/sostenibilidad/baterias?id=${id}`,
    )
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

// Llantas

const getLlantas = async () => {
  try {
    const response = await apiService.get('/sostenibilidad/llantas')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postLlanta = async (body) => {
  try {
    const response = await apiService.post('/sostenibilidad/llantas', body)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

const deleteLlanta = async (id) => {
  try {
    const response = await apiService.delete(`/sostenibilidad/llantas?id=${id}`)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

// Agua

const getAgua = async () => {
  try {
    const response = await apiService.get('/sostenibilidad/agua')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postAgua = async (body) => {
  try {
    const response = await apiService.post('/sostenibilidad/agua', body)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

// Energia

const getEnergias = async () => {
  try {
    const response = await apiService.get('/sostenibilidad/energia')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postEnergia = async (body) => {
  try {
    const response = await apiService.post('/sostenibilidad/energia', body)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

const deleteEnergia = async (id) => {
  try {
    const response = await apiService.delete(`/sostenibilidad/energia?id=${id}`)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

// Gas

const getGas = async () => {
  try {
    const response = await apiService.get('/sostenibilidad/gas')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postGas = async (body) => {
  try {
    const response = await apiService.post('/sostenibilidad/gas', body)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

const deleteGas = async (id) => {
  try {
    const response = await apiService.delete(`/sostenibilidad/gas?id=${id}`)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

// Tipos

const getTipos = async () => {
  try {
    const response = await apiService.get('/sostenibilidad/tipos')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getTipoById = async (id) => {
  try {
    const response = await apiService.get(`/sostenibilidad/tipos?tipo_id=${id}`)
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postTipo = async (body) => {
  try {
    const response = await apiService.post('/sostenibilidad/tipos', body)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

const deleteTipo = async (id) => {  
  try {
    const response = await apiService.delete(`/sostenibilidad/tipos?id=${id}`)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

// Roles

const getRoles = async () => {
  try {
    const response = await apiService.get('/sostenibilidad/roles')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const addRol = async (body) => {
  try {
    const response = await apiService.post('/sostenibilidad/roles', body)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}



// Permisos

const getPermisosByRol = async (idRol) => {
  try {
    const response = await apiService.get(`/sostenibilidad/roles?rol_id=${idRol}`)
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getPermisosByUser = async () => {
  try {
    const response = await apiService.get(`/sostenibilidad/mis_permisos`)
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const addPermiso = async (body) => {
  try {
    const response = await apiService.post('/sostenibilidad/roles_permisos', body)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

// USUARIOS

const getUsuarios = async () => {
  try {
    const response = await apiService.get('/sostenibilidad/usuarios')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postUsuario = async (body) => {
  try {
    const response = await apiService.post('/sostenibilidad/usuarios', body)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}

const postCambiarRol = async (body) => {
  try {
    const response = await apiService.post('/sostenibilidad/roles_usuarios', body)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}


const editUsuario = async (body) => {
  try {
    const response = await apiService.put('/sostenibilidad/usuarios', body)
    if (response.status === 200) {
      return response
    }
    return false
  } catch (error) {
    return false
  }
}


// Sedes

const getSedes = async () => {
  try {
    const response = await apiService.get('/sostenibilidad/sedes')
    if (response.status === 200) {
      return response.data
    }
    return false
  }
  catch (error) {
    return false
  }
}

const addSedeToEmpresa = async (empresaId, sedeId) => {
  try {
    const response = await apiService.post('/sostenibilidad/ensambladoras_sedes', { ensambladora_id: empresaId, sede_id: sedeId })
    if (response.status === 200) {
      return response.data
    }
    return false
  }
  catch (error) {
    return false
  }
}

const postSede = async (body) => {
  try {
    const response = await apiService.post('/sostenibilidad/sedes', body)
    if (response.status === 200) {
      return response
    }
    return false
  }
  catch (error) {
    return false
  }
}

// Residuos

const getResiduos = async () => {
  try {
    const response = await apiService.get('/sostenibilidad/residuos')
    if (response.status === 200) {
      return response.data
    }
    return false
  }
  catch (error) {
    return false
  }
}

const postResiduo = async (body) => {
  try {
    const response = await apiService.post('/sostenibilidad/residuos', body)
    if (response.status === 200) {
      return response
    }
    return false
  }
  catch (error) {
    return false
  }
}

const deleteResiduo = async (id) => {
  try {
    const response = await apiService.delete(`/sostenibilidad/residuos?id=${id}`)
    if (response.status === 200) {
      return response
    }
    return false
  }
  catch (error) {
    return false
  }
}

const deleteAgua = async (id) => {
  try {
    const response = await apiService.delete(`/sostenibilidad/agua?id=${id}`)
    if (response.status === 200) {
      return response
    }
    return false
  }
  catch (error) {
    return false
  }
}

const deleteEnsambladora = async (id) => {
  try {
    const response = await apiService.delete(`/sostenibilidad/ensambladoras?id=${id}`)
    if (response.status === 200) {
      return response
    }
    return false
  }
  catch (error) {
    return false
  }
}

const deleteSede = async (id) => {
  try {
    const response = await apiService.delete(`/sostenibilidad/sedes?id=${id}`)
    if (response.status === 200) {
      return response
    }
    return false
  }
  catch (error) {
    return false
  }
}

export {
  getEmpresas,
  postEmpresa,
  editEmpresa,
  getBaterias,
  postBateria,
  deleteBateria,
  getLlantas,
  postLlanta,
  deleteLlanta,
  getEnergias,
  postEnergia,
  getAgua,
  postAgua,
  deleteEnergia,
  getGas,
  postGas,
  deleteGas,
  getTipos,
  getTipoById,
  postTipo,
  getRoles,
  getPermisosByRol,
  addPermiso,
  addRol,
  getUsuarios,
  postUsuario,
  editUsuario,
  getPermisosByUser,
  getSedes,
  addSedeToEmpresa,
  postSede,
  getEnsambladoras,
  postEnsambladora,
  putEnsambladora, 
  deleteEmpresa,
  getResiduos,
  postResiduo,
  deleteTipo,
  postCambiarRol,
  deleteResiduo,
  deleteEnsambladora,
  deleteSede,
  deleteAgua
}
